module.exports = __webpack_public_path__ + "static/empty-states-headlines-do-fe70862ff6b8b7b33eab9eff80cf29f0.png";